<ion-card class="legend-card">
    <ion-card-header>
        <ion-card-title>{{ Title }}</ion-card-title>
    </ion-card-header>

    <ion-card-content>
        <div class="legend-inline">
            <div class="legend-item" *ngFor="let item of Items">
                <ion-icon [name]="item.Icon" [color]="item.Color"></ion-icon>
                <span class="legend-name">{{ item.Name }}</span>
            </div>
        </div>
    </ion-card-content>
</ion-card>